import {bookApi} from '@vio/core/src/booking/services/bookApi'

type BookingStatusSubscription = ReturnType<
  ReturnType<typeof bookApi.endpoints.getBookingStatus.initiate>
>

export interface BookingStatusPollingController {
  start: (subscription: BookingStatusSubscription) => void
  stop: () => void
}

export const createBookingStatusPollingController =
  (): BookingStatusPollingController => {
    let activeSubscription: BookingStatusSubscription | undefined

    return {
      start: subscription => {
        if (activeSubscription) {
          subscription.unsubscribe()
          return
        }
        activeSubscription = subscription
      },
      stop: () => {
        activeSubscription?.unsubscribe()
        activeSubscription = undefined
      }
    }
  }
